import handleActions from 'redux-actions/es/handleActions';
import {
  isLogin,
  getOverdueDays,
  getUserName,
  isShowOverduePrompt,
  getUserEmail
} from '../../utils/login';
import {
  toggleOverduePromptSuccess,
  updateUserInfoSuccess,
  verifySuccess,
  setRedirect
} from './actions';

export default handleActions(
  {
    [toggleOverduePromptSuccess.toString()]: (
      state,
      { payload: isShowOverduePrompt }
    ) => {
      return {
        ...state,
        isShowOverduePrompt
      };
    },
    [updateUserInfoSuccess.toString()]: (
      state,
      { payload: { userName, overdueDays, email, privilegedAccount } }
    ) => {
      return {
        ...state,
        userName,
        overdueDays,
        email,
        privilegedAccount
      };
    },
    [verifySuccess.toString()]: state => {
      return {
        ...state,
        isLogin: true
      };
    },
    [setRedirect.toString()]: (state, { payload: redirect }) => {
      return {
        ...state,
        redirect
      };
    }
  },
  {
    isLogin: isLogin(),
    userName: getUserName(),
    overdueDays: getOverdueDays(),
    isShowOverduePrompt: isShowOverduePrompt(),
    redirect: '/',
    email: getUserEmail(),
    privilegedAccount: false
  }
);
